// TODO: Once the entire app is migrated to DesignSystemProvider, switch back to the
// hook-based implementation below (remove the bridge singleton and DialogsRegistrar).
// The hook-based version is simpler and self-contained.
import { useMemo } from 'react'

import { Tooltip } from '../Tooltip'

import { DialogContent } from './DialogContent'
import { DIALOG_CONFIG } from './constants'
import type { DialogKind } from './constants'
import { getDialogsBridge } from './dialogsBridge'
import type { DialogOptions } from './types'

function showDialog(kind: DialogKind, options: DialogOptions = {}) {
  const bridge = getDialogsBridge()

  if (!bridge) {
    return
  }

  const { modal, token, styles } = bridge
  const config = DIALOG_CONFIG[kind]
  const {
    title = config.defaults.title,
    okText = config.defaults.okText,
    cancelText = config.defaults.cancelText,
    content = config.defaults.content,
    icon,
    okCancel,
    onOk,
    onCancel
  } = options

  const iconColor = token[config.colorToken]

  const titleNode = (
    <Tooltip title={title} placement="top">
      <span className={styles.dialogTitle}>{title}</span>
    </Tooltip>
  )

  return modal.confirm({
    rootClassName: styles.dialog,
    title: titleNode,
    icon: null,
    closable: true,
    content: (
      <DialogContent
        icon={icon ?? config.icon}
        iconColor={iconColor}
        description={content}
      />
    ),
    okText,
    cancelText,
    okCancel,
    okButtonProps:
      'danger' in config && config.danger ? { danger: true } : undefined,
    onOk,
    onCancel,
    centered: true,
    width: 320
  })
}

export function showErrorModal(options: DialogOptions = {}) {
  return showDialog('error', { okCancel: false, okText: 'OK', ...options })
}

export function useDialogs() {
  return useMemo(
    () => ({
      showSuccess: (options?: DialogOptions) => showDialog('success', options),
      showInfo: (options?: DialogOptions) => showDialog('information', options),
      showError: (options?: DialogOptions) => showDialog('error', options),
      showWarning: (options?: DialogOptions) => showDialog('warning', options),
      showDelete: (options?: DialogOptions) => showDialog('delete', options),
      showUnsavedChanges: (options?: DialogOptions) =>
        showDialog('unsavedChanges', options),
      showPermissionRequired: (options?: DialogOptions) =>
        showDialog('permissionRequired', options),
      showConfirm: (options?: DialogOptions) => showDialog('confirm', options)
    }),
    []
  )
}

// --- Hook-based implementation (use when app is fully on DesignSystemProvider) ---
//
// import { App, theme } from 'antd'
// import { Tooltip } from '../Tooltip'
// import { DialogContent } from './DialogContent'
// import { DIALOG_CONFIG } from './constants'
// import type { DialogKind } from './constants'
// import { useDialogStyles } from './styles'
// import type { DialogOptions } from './types'
//
// function useDialog() {
//   const { modal } = App.useApp()
//   const { token } = theme.useToken()
//   const { styles } = useDialogStyles()
//
//   return (kind: DialogKind, options: DialogOptions = {}) => {
//     const config = DIALOG_CONFIG[kind]
//     const {
//       title = config.defaults.title,
//       okText = config.defaults.okText,
//       cancelText = config.defaults.cancelText,
//       content,
//       icon,
//       onOk,
//       onCancel
//     } = options
//
//     const iconColor = token[config.colorToken]
//
//     const titleNode = (
//       <Tooltip title={title} placement="bottom">
//         <span className={styles.dialogTitle}>{title}</span>
//       </Tooltip>
//     )
//
//     return modal.confirm({
//       rootClassName: styles.dialog,
//       title: titleNode,
//       icon: null,
//       closable: true,
//       content: (
//         <DialogContent
//           icon={icon ?? config.icon}
//           iconColor={iconColor}
//           description={content}
//         />
//       ),
//       okText,
//       cancelText,
//       okButtonProps:
//         'danger' in config && config.danger ? { danger: true } : undefined,
//       onOk,
//       onCancel,
//       centered: true,
//       width: 320
//     })
//   }
// }
//
// export function useDialogs() {
//   const show = useDialog()
//   return {
//     showSuccess: (options?: DialogOptions) => show('success', options),
//     showInfo: (options?: DialogOptions) => show('information', options),
//     showError: (options?: DialogOptions) => show('error', options),
//     showWarning: (options?: DialogOptions) => show('warning', options),
//     showDelete: (options?: DialogOptions) => show('delete', options),
//     showUnsavedChanges: (options?: DialogOptions) => show('unsavedChanges', options),
//     showPermissionRequired: (options?: DialogOptions) => show('permissionRequired', options),
//     showConfirm: (options?: DialogOptions) => show('confirm', options)
//   }
// }
